module.exports = __webpack_public_path__ + "static/media/f.6cb786e9.png";